/**
 * HVAC Stamps and Labels Constants
 * Defines preset stamps for HVAC markup and labeling
 */

// Status stamps - indicate work status
export const STATUS_STAMPS = [
  { id: 'new', label: 'NEW', color: '#4caf50', textColor: '#fff', category: 'status' },
  { id: 'existing-keep', label: 'EXISTING\nKEEP', color: '#2196f3', textColor: '#fff', category: 'status' },
  { id: 'existing-remove', label: 'EXISTING\nREMOVE', color: '#f44336', textColor: '#fff', category: 'status' },
  { id: 'relocate', label: 'RELOCATE', color: '#ff9800', textColor: '#fff', category: 'status' },
];

// Action stamps - indicate required actions
export const ACTION_STAMPS = [
  { id: 'seal-duct', label: 'SEAL\nDUCT', color: '#ffeb3b', textColor: '#333', category: 'action' },
  { id: 'add-insulation', label: 'ADD\nINSULATION', color: '#9c27b0', textColor: '#fff', category: 'action' },
  { id: 'check-airflow', label: 'CHECK\nAIRFLOW', color: '#ff9800', textColor: '#fff', category: 'action' },
  { id: 'repair', label: 'REPAIR', color: '#f44336', textColor: '#fff', category: 'action' },
  { id: 'replace', label: 'REPLACE', color: '#d32f2f', textColor: '#fff', category: 'action' },
];

// Inspection stamps - indicate inspection results
export const INSPECTION_STAMPS = [
  { id: 'ok', label: '✓ OK', color: '#4caf50', textColor: '#fff', category: 'inspection', icon: 'check' },
  { id: 'fail', label: '✗ FAIL', color: '#f44336', textColor: '#fff', category: 'inspection', icon: 'x' },
  { id: 'attention', label: '! NEEDS\nATTENTION', color: '#ffc107', textColor: '#333', category: 'inspection', icon: 'warning' },
];

// All stamps combined
export const ALL_STAMPS = [...STATUS_STAMPS, ...ACTION_STAMPS, ...INSPECTION_STAMPS];

// Get stamp definition by ID
export function getStampById(stampId) {
  return ALL_STAMPS.find(s => s.id === stampId);
}

// Stamp categories for UI organization
export const STAMP_CATEGORIES = [
  { id: 'status', label: 'Status', stamps: STATUS_STAMPS },
  { id: 'action', label: 'Actions', stamps: ACTION_STAMPS },
  { id: 'inspection', label: 'Inspection', stamps: INSPECTION_STAMPS },
];

// Label types
export const LABEL_TYPES = {
  CFM: {
    id: 'cfm',
    suffix: 'CFM',
    color: '#00c8ff',
    defaultValue: 100,
  },
  DUCT_SIZE: {
    id: 'duct-size',
    suffix: '"',
    color: '#e65100',
    defaultValue: '6',
  },
  EQUIPMENT: {
    id: 'equipment',
    suffix: '',
    color: '#66bb6a',
    defaultValue: '',
  },
  ROOM_LOAD: {
    id: 'room-load',
    suffix: '',
    color: '#9c27b0',
    defaultValue: '',
  },
};

// Default stamp size
export const STAMP_SIZE = {
  width: 80,
  height: 40,
  fontSize: 10,
  padding: 6,
  borderRadius: 4,
};

// Default label size
export const LABEL_SIZE = {
  minWidth: 50,
  height: 24,
  fontSize: 12,
  padding: 6,
  borderRadius: 4,
  arrowLength: 30,
};
